import { useNotificationsCenter } from '@contexts/NotificationsCenterContext';
import { NotificationsCenterHeader } from './NotificationsCenterHeader';
import { NotificationsCenterList } from './NotificationsCenterList';
import { NotificationsCenterListEmpty } from './NotificationsCenterListEmpty';

export default function NotificationsCenter() {
  const { notifications } = useNotificationsCenter();

  return (
    <div className="w-[440px] max-h-[500px] flex flex-col">
      <NotificationsCenterHeader />
      {notifications.length === 0 ? <NotificationsCenterListEmpty /> : <NotificationsCenterList />}
    </div>
  );
}
